import '@/css/final/index.scss';
require('./sections/profile');
require('./sections/similar')
var _ = require('underscore');
var pingjs = require('widgets/ping');
var MiniTip = require('widgets/MiniTip');

if (/newgame.local/.test(location.href)) {
  $('body').append('<script src="//ue.17173cdn.com/a/module/tg-widget/source/game-top/v1-2/index.js"></script><script src="https://ue.17173cdn.com/a/module/tg-widget/source/17173app-qrcode/v1-0/index.js?v=6164"></script>')
}

var app = {
  init: function () {
    app.bind()
    app.slick()
    app.mainTab()
    app.dialog()
    app.user()
    app.introExtend()
    app.renderRank()
    app.rederFollow()
    app.audioPlay()
    app.renderAct()
    app.renderAwardGames()
    $(window).on('load resize', function () {
      app.fixed()
    })
    MiniTip.applyWithIn('[data-mini-tip]')
    pingjs.applyTrackBlock()
    pingjs.applyTrackLink()
    pingjs.applyBgArea()
  },
  bind: function () {
    lightbox.option({
      'resizeDuration': 400,
      // 'disableScrolling':true,
    })
    $('.item-pic').on('click', function () {
      $('#lightboxWrap').show()
    })
    $('.lb-close,#lightboxWrap').on('click', function () {
      $('#lightboxWrap').fadeOut(500)
    })
    // 预约组件互通
    window.ued && window.ued.emitter && ued.emitter.on('GAMERESERVE-FOLLOWED', function () {
      if ($('.gb-newgame-channel').text() == '预约') {
        $('.gb-newgame-comm-btn').addClass('disable')
        $('.gb-newgame-channel').text('已预约')
      }
    })
    window.ued && window.ued.emitter && ued.emitter.on('GAMETOP-FOLLOWED', function () {
      $('.game-follow-bt').click()
    })
  },
  fixed: function () {
    var windowHeight = $(window).height(); // 浏览器自身的高度
    function checkFixed(ele) { // 传入一个元素的jq对象
      var scrollTop = $(window).scrollTop();  //即页面向上滚动的距离
      var offsetTop = ele.offset().top + ele.height();  //目标元素相对于document顶部的位置
      //在2个临界状态之间的就为出现在视野中的
      if (offsetTop < (scrollTop + windowHeight)) {
        return true;
      } else {
        return false;
      }
    }

    $('.game-questionnaire').height($('.game-questionnaire .fixed-con').height())
    $('.js-fixed-wrap').height($('.js-fixed-wrap .fixed-con').height())
    var ti = setInterval(function () {
      if ($('.mod-17173app-qrcode').length) {
        $('.js-fixed-wrap').height($('.js-fixed-wrap .fixed-con').height())
        clearInterval(ti)
      }
    }, 1000)

    $(window).on('scroll', function () {
      $('.js-fixed-wrap').each(function () {
        var _this = $(this)
        // fixed元素高度大于屏幕高度
        if (_this.height() > windowHeight || _this.height() > windowHeight) {
          $('.fixed-con', _this).removeClass('fixed-top')
          if (checkFixed(_this)) {
            $('.fixed-con', _this).addClass('fixed-bottom')
          } else {
            $('.fixed-con', _this).removeClass('fixed-bottom')
          }
        } else {
          $(window).scrollTop() > _this.offset().top ? $('.fixed-con', _this).addClass('fixed-top') : $('.fixed-con', _this).removeClass('fixed-top')
        }
      })
      $('.mod-17173app-qrcode-con').length &&
        $(window).scrollTop() > $('.mod-17173app-qrcode').offset().top ? $('.mod-17173app-qrcode-con').addClass('fixed-top') : $('.mod-17173app-qrcode-con').removeClass('fixed-top')
    })
  },
  dialog: function () {
    $('[data-dialog]').on('click', function () {
      var dialogName = $(this).attr('data-dialog')
      $('.dialog-' + dialogName).show()
      if (dialogName == 'video') {
        var iframeSrc = $(this).data('video').split('/', -1)[4];
        var html = '<iframe class="vplayer" width="100%" height="100%" src="//v.17173.com/player_ifrm2/ ' + iframeSrc + '" scrolling="no" frameborder="0" allowfullscreen></iframe>';
        $('.dialog-video').find('.dialog-bd').html(html);
      }
    })

    $('.dialog .btn-close').on('click', function () {
      $(this).parents('.dialog').hide();
      $(this).parents('.dialog').hasClass('dialog-video') && $(this).parents('.dialog').find('.dialog-bd').html('')
    });
  },
  slick: function () {
    var $focus_list = $('.js-focus').find('.focus-list')
    $focus_list.slick({
      lazyLoad: 'ondemand',
      slidesToScroll: 1,
      variableWidth: true,
      dots: false,
      infinite: true,
      speed: 500,
      autoplay: false,
      focusOnSelect: true,
    })
    // 视频
    $('.js-view-video').each(function () {
      var iframeSrc = $(this).find('.box-video').data('url').split('/', -1)[4];
      var html = '<iframe class="vplayer" width="100%" height="100%" src="//v.17173.com/player_ifrm2/ ' + iframeSrc + '" scrolling="no" frameborder="0" allowfullscreen></iframe>';
      $(this).find('.box-iframe-video').html(html)
      $focus_list.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        if (nextSlide != 0) {
          $(this).find('.box-iframe-video').html('')
        } else {
          $(this).find('.box-iframe-video').html(html)
        }
      })
    })

    $('.slick-slide', $focus_list).each(function () {
      if (!$(this).hasClass('slick-cloned')) {
        $(this).find('.item-pic a').attr({
          'data-lightbox': 'pics',
          href: $(this).find('img').attr('src').split('!')[0]
        })
      }
    })
  },
  mainTab: function () {
    var $mainTab = $('.main-tab .tab-in>[data-tab]')
    var topOffsetTop = $('.main-tab').offset().top
    var mainHeight = $('.main-tab').height()

    $('.main-tab .tab-in a').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active');
    });

    $mainTab.on('click', function () {
      var index = $(this).index();
      $('.main-tab .tab-pn .tab-pn-con').eq(index).show().siblings().hide();
      $('html, body').stop().animate({
        scrollTop: topOffsetTop
      }, 0)
    });

    $('.law a').on('click', function () {
      $('.js-tab-cmt').trigger('click')
    });
    $('.js-tab-cmt').on('click', function () {
      // $('.main-tab .tab-pn .tab-pn-con').eq(0).show().siblings().hide()
	  $('.pn-comment').parents('.tab-pn-con').show().siblings().hide()
      $('html, body').stop().animate({
        scrollTop: $('.pn-comment').offset().top - 165
      }, 200)
    });

    $('.js-tab').each(function () {
      var tabNav = $(this).find('.tab-nav-list')
      var tabPn = $(this).find('.tab-pn-news')
      $(tabNav).find('a').on('click', function () {
        var i = $(this).index()
        $(this).addClass('active').siblings().removeClass('active')
        tabPn.find('.tab-pn-news-con').eq(i).show().siblings('.tab-pn-news-con').hide()
      })
    })

    var onScroll = function () {
      if ($('.main-tab').offset().top != topOffsetTop) {
        topOffsetTop = $('.main-tab').offset().top
      }
      if ($('.main-tab').height() != mainHeight) {
        mainHeight = $('.main-tab').height()
      }
      if ($(document).scrollTop() > topOffsetTop) {
        $('.main-tab .tab-in').addClass('fixed');
      } else {
        $('.main-tab .tab-in').removeClass('fixed');
      }

      if ($(document).scrollTop() > $('.header').height() - 400) {
        $('.pn-float-final').show();
      } else {
        $('.pn-float-final').hide();
      }
    }

    $(window).on('scroll', onScroll);

    $('.btn-gotop').on('click', function () {
      $('html, body').stop().animate({
        scrollTop: 0,
      }, 500);
    });

    pandora.use(['qrcode'], function (Qrcode) {
      var qqUrl = $('#code-qq').data('url');
      new Qrcode({
        element: '#code-qq',
        text: qqUrl,
        size: 92,
        image: 'https://ue.17173cdn.com/a/newgame/final/202107/img/ico-qq.png',
        imageSize: 28,
      });
    });
  },
  user: function () {
    var setAvatar = function () {
      var url = Passport.getUserPortrait(Passport.data('uid').toString(), 1)
      $('.header-c1 .btn-login img').attr({
        'src': url,
        'href': 'https://passport.17173.com/main'
      })
    }

    if (Passport.isLoggedIn()) {
      $('.header-c1 .btn-remind').addClass('login');
      setAvatar();
    }
    Passport.on(Passport.EVENTS.loginSuccess, function (events) {
      setAvatar();
    });
    $('[data-login]').click(function () {
      if (!Passport.isLoggedIn()) {
        Passport.Dialog.show();
        return;
      }
    });
  },
  // 简介展开收起
  introExtend: function () {
    $('.js-extend').each(function () {
      var $this = $(this)
      var $txt = $(this).find('.box-txt')
      var $ViewMore = $(this).find('.view-more')
      $txt.height() > 66 ? $ViewMore.show() : $ViewMore.hide()
      $ViewMore.click(function () {
        if ($(this).text() == '展开') {
          $(this).text('收起')
          $this.addClass('show')
        } else {
          $(this).text('展开')
          $this.removeClass('show')
        }
      })
    })
  },
  // 关注数 下载数 游戏下载链接渲染
  rederFollow: function () {
    // 关注数
    $.ajax({
      url: '//api.17173.com/hao/v1/getGameScheCount',
      data: {
        game_codes: gameCode
      },
      dataType: 'jsonp',
    }).done(function (res) {
      (res.data[gameCode] && res.data[gameCode] > 99) && $('[data-follow-count]').text(res.data[gameCode]).parents('.item').show()
      var followCount = res.data[gameCode];
      if (followCount) {
        if (followCount >= 10000) {
          $('[data-follow-count-v2]').text((followCount / 10000).toFixed(1) + '万');
        } else {
          $('[data-follow-count-v2]').text(followCount);
        }
      } else { 
        $('[data-follow-count-v2]').text('暂无');
      }
    })

    // 下载数
    var fetchGameDownLoad = function (gameCode) {
      return $.ajax({
        url: '//d.17173cdn.com/download/game/js/' + gameCode + '.js',
        dataType: 'script',
        scriptCharset: 'utf-8',
        cache: true
      })
    }
    fetchGameDownLoad(gameCode).done(function () {
      var datastore = window.DATASTORE || window.DATASTORELAB || {}
      var DownNumInfo = datastore['game.downnum'] || {}
      var currentDownNum = DownNumInfo[gameCode] || {}
      if (currentDownNum.downnum) {
        $('[data-down-num]').text(currentDownNum.downnum)
        $('[data-down-num]').parents('.item').show()
      }
    })

  },
  // 排行榜
  renderRank: function (data) {
    var fetchSubRank = function (subRankListUrl) {
      $.ajax({
        url: 'https://api.17173.com/merge-interface/v1/game-rank',
        dataType: "jsonp",
        data: {
          gameCode: gameCode,
          rankingUrl: subRankListUrl
        },
        success: function (d) {
          $('.hot-rank .rank').html('<a href="' + d.data.rankingUrl + '" target="_blank" data-track-link="muIRFr"><span>' + d.data.rankingName + '</span><br>第<span class="num">' + d.data.rank + '</span>名</a>')
          $('.js-hot-rank').html('<a href="' + d.data.rankingUrl + '" target="_blank"  class="name name-link-ex"><span class="icon icon-rank"></span>' + d.data.rankingName + '<span class="icon-arrow"></span></a><div class="val val-fb">#' + d.data.rank + '</div>')
        }
      })
    };

    var fetchGameRankInfo = function (gameCode) {
      return $.ajax({
        url: '//d.17173cdn.com/game-top/info/js/' + gameCode + '.js',
        dataType: 'script',
        scriptCharset: 'utf-8',
        cache: true
      })
    };
    var renderRankView = function (currentTopInfo) {
      var rankName, rankUrl, isOnlineGame = false, subRankListUrl
      if (currentTopInfo.rank_type === 'NEW') {
        rankName = '新游期待榜'
        rankUrl = '//top.17173.com/list-1-0-0-0-0-0-0-0-0-0-1.html'
        subRankListUrl = 'http://top.17173.com/list-1-0-0-0-0-0-0-0-0-0-1.html'
        isOnlineGame = true
      } else if (currentTopInfo.rank_type === 'HOT') {
        rankName = '热门游戏榜'
        rankUrl = '//top.17173.com/list-2-0-0-0-0-0-0-0-0-0-1.html'
        subRankListUrl = 'http://top.17173.com/list-2-0-0-0-0-0-0-0-0-0-1.html'
        isOnlineGame = true
      } else if (currentTopInfo.rank_type === 'EXPECT') {
        rankName = '手游期待榜'
        rankUrl = '//top.17173.com/list-1-0-4-0-0-0-0-0-0-0-1.html'
        subRankListUrl = 'http://top.17173.com/list-1-0-4-0-0-0-0-0-0-0-1.html'
      } else {
        rankName = '手游热门榜'
        rankUrl = '//top.17173.com/list-2-0-4-0-0-0-0-0-0-0-1.html'
        subRankListUrl = 'http://top.17173.com/list-2-0-4-0-0-0-0-0-0-0-1.html'
      }
      var info = {
        rankNumber: currentTopInfo.rank_num,
        rankName: rankName,
        rankUrl: rankUrl,
        voteNumber: currentTopInfo.heats_num,
        hasVoteAct: window.ued.voteActFlag,
        isOnlineGame: isOnlineGame,
        rankUnlessEmpty: !_.isEmpty(currentTopInfo) && currentTopInfo.rank_num,
        subRankListUrl: subRankListUrl
      }
      if (info.rankUnlessEmpty == 0) {
        $('[data-rank-url],.hot-rank .js-vote').hide()
        $('.js-hot-rank').hide()
      } else {
        $('.download-rank .status').addClass('ex')
        $('[data-rank-url],.hot-rank .js-vote').show()
        $('.js-hot-rank').show()
        fetchSubRank(subRankListUrl, info.rankName)
      }
    }
    fetchGameRankInfo(gameCode).done(function () {
      var datastore = window.DATASTORE || window.DATASTORELAB || {}
      var topInfo = datastore['game-top.info'] || {}
      var currentTopInfo = topInfo[gameCode] || {}
      renderRankView(currentTopInfo)
    })
  },
  // 音频播放
  audioPlay: function () {
    $('.ots-list>li').on('click', function () {
      $('.ost-item audio')[0].pause();
      var src = $(this).data('ots');
      $(this).addClass('active').siblings().removeClass('active');
      $('.ost-item source').attr('src', src);
      $('.ost-item audio')[0].load();
      $('.ost-item audio')[0].currentTime = 0;
      $('.ost-item audio')[0].play();
    });
  },
  // 最新活动 走活动平台
  renderAct: function () {
    function goToBl() {
      // 定位到新闻爆料
      if ($('#bl_news').length && location.href.indexOf('#bl_news') > -1) {
        $('html, body').stop().animate({
          scrollTop: $('#bl_news').offset().top - 165,
        }, 200);
      }
    }
    if ($('[data-actid]').length) {
      var actId = $('[data-actid]').data('actid')
      $.ajax({
        url: 'https://actapp.17173.com/api/v2/activity/' + actId + '/info',
        dataType: 'jsonp',
        success: function (res) {
          $('[data-actid]').html('<div class="mod mod-test"><div class="hd">最新活动<a href="' + res.activityUrl + '"target="_blank" class="btn-go-act">参与活动</a></div><div class="bd"><ul class="ptlist ptlist-test"><li><div class="pic"><a href="' + res.activityUrl + '" target="_blank"><img src="' + res.activityImage + '" width="160" height="120" alt="" /></a></div><div class="box-txt"><div class="tit"><a href="' + res.activityUrl + '" target="_blank">' + res.name + '</a></div><div class="txt">' + res.description + '</div></div></li></ul></div></div>')
          if (location.href.indexOf('#act') > -1) {
            $('html, body').stop().animate({
              scrollTop: $('[data-actid]').offset().top - 165,
            }, 0);
          }
          goToBl()
        }
      })
    } else {
      goToBl()
    }
  },
  //该奖项的游戏列表
  renderAwardGames: function () {
    $('.best-game li').on('click', function () {
      var i = $(this).data('id')
      var awardName = '《' + $(this).find('p:eq(0)').text() + '》' + $(this).find('p:eq(1)').text()
      $.ajax({
        url: './game-awards-' + i + '.html',
        success: function (res) {
          var html = []
          res.map(function (v) {
            html.push(awardGameHtml(v))
          })
          $('.dialog-awards .dialog-hd .tit').html(awardName)
          $('.dialog-awards .game-list').html(html.join(''))
          $('.dialog-awards').show()
        }
      })
      function awardGameHtml(data) {
        var imgPath = data.logo_pic + '!a-3-240x.' + data.logo_pic.substring(data.logo_pic.lastIndexOf(".") + 1)
        return '<div class="item"><a href="' + data.game_url + '" target="_blank"><img src="' + imgPath + '"/><div class="game-name">' + data.game_name + '</div></a></div>'
      }
    })
  },
}
$(function () {
  app.init()
})